module.exports = __webpack_public_path__ + "static/calfire-6c7fc6e4cfea1d21d018c602f165f777.png";